import { ShieldOff } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function ForbiddenPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <div className="inline-flex p-4 rounded-full bg-red-50 dark:bg-red-900/20 mb-4">
          <ShieldOff size={40} className="text-red-500" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-2">
          Accès restreint
        </h1>
        <p className="text-gray-500 dark:text-gray-400 mb-6 max-w-md">
          Vous n'avez pas la permission d'accéder à cette page.
          Contactez le propriétaire du compte pour obtenir l'accès.
        </p>
        <button
          onClick={() => navigate('/')}
          className="px-4 py-2 text-sm font-medium bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors"
        >
          Retour à l'accueil
        </button>
      </div>
    </div>
  );
}
